/* ==========================================================================
   MASHWI — Fenêtre « trois questions, 10 % »

   Parcours : question 1 → question 2 → question 3 → courriel → code affiché.
   Les étapes s'enchaînent par les attributs data-mw-suivant / data-mw-retour
   du balisage : ajouter ou retirer une question ne demande aucun changement ici.

   🔄 CHANGEMENT DU 2026-08-14 — LE COURRIEL PART CHEZ KLAVIYO, EN ARRIÈRE-PLAN.
   Il passait par le formulaire client natif de Shopify : POST classique,
   RECHARGEMENT de page, puis réouverture de la fenêtre sur le code grâce à un
   drapeau de session. Deux raisons de l'abandonner, toutes deux mesurées :
     · hCaptcha est branché sur ce formulaire (CDC §11). Quand le filtre sert un
       défi — navigateur piloté, VPN, relais privé iOS — le POST ne part JAMAIS.
       La page se recharge, la fenêtre ne se rouvre pas, et le courriel COMME
       les trois réponses sont perdus sans laisser de trace nulle part.
     · le rechargement lui-même coûtait le parcours : on quittait la page pour
       y revenir, en pariant sur un drapeau qui ne survit pas à tout.
   L'API client de Klaviyo n'a ni captcha ni rechargement, et retient les
   réponses en propriétés de profil. Tout le code « data-poste / data-erreur /
   drapeau d'envoi » a disparu avec le rechargement qui le justifiait.

   Une réponse est mémorisée DÈS LE CLIC, avant même le courriel : si la
   personne ferme la fenêtre ici et s'inscrit plus tard par le pied de page,
   ses réponses partent quand même avec elle (assets/mashwi-klaviyo.js).

   Trafic des publicités Meta : quand data-pub-meta vaut 1, la fenêtre reste
   muette pour tout visiteur arrivé avec fbclid ou une utm_source Meta — Meta
   relit la page d'atterrissage quand il révise une annonce, et le libellé du
   rabais ne doit pas compter contre elle. Le paramètre n'existe qu'à
   l'atterrissage, alors la consigne est retenue en session pour les pages
   suivantes.
   ========================================================================== */

(function () {
  'use strict';

  var CLE_PUB_META = 'mw-popup-pub-meta';
  var CLE_AFFILIATION = 'mw-popup-affiliation';
  var SOURCES_META = ['facebook', 'instagram', 'meta', 'fb', 'ig', 'fbig'];

  function venuDesPubsMeta() {
    try {
      if (window.sessionStorage.getItem(CLE_PUB_META) === '1') return true;
    } catch (e) {}
    var params = new URLSearchParams(window.location.search);
    var source = (params.get('utm_source') || '').toLowerCase();
    if (!params.has('fbclid') && SOURCES_META.indexOf(source) === -1) return false;
    try {
      window.sessionStorage.setItem(CLE_PUB_META, '1');
    } catch (e) {
      /* pas de session : au pire, la fenêtre reviendra sur la page suivante */
    }
    return true;
  }

  /**
   * Le visiteur vient-il du lien d'un affilié ?
   *
   * POURQUOI CETTE GARDE EXISTE — c'est de l'argent, pas du confort.
   * Le lien d'affiliation applique DÉJÀ le rabais de l'affilié (5 % pour
   * JOELLE5, réglage GoAffPro `apply_discount_on_link`). Si la fenêtre s'ouvre
   * par-dessus, elle propose CARNET10 à 10 % : le visiteur échange 5 % contre
   * 10 %, la vente reste attribuée à l'affilié par son cookie — et la boutique
   * paie 34 $ de rabais au lieu de 17 $ sur l'Ensemble, PLUS la commission.
   * Chiffré : 64,60 $ de coût programme au lieu de 49,30 $, soit −14,83 $ par
   * commande. Ce n'est pas un cas de bord : c'est le comportement par défaut
   * de n'importe quel acheteur qui voit deux offres et prend la plus grosse.
   *
   * Détection (source : le chargeur GoAffPro servi sur la boutique) :
   *   · paramètre d'URL « ref » ou « aff » — les identifiants configurés ici ;
   *   · localStorage « gfp_persist » — posé par le chargeur au premier clic ;
   *   · tout témoin dont le nom contient gfp / goaffpro.
   * La consigne est retenue en session : le paramètre n'existe qu'à
   * l'atterrissage, la garde doit tenir sur les pages suivantes.
   */
  function venuDUnAffilie() {
    try {
      if (window.sessionStorage.getItem(CLE_AFFILIATION) === '1') return true;
    } catch (e) {}

    var repere = false;
    var params = new URLSearchParams(window.location.search);
    if (params.get('ref') || params.get('aff')) repere = true;

    if (!repere) {
      try {
        if (window.localStorage.getItem('gfp_persist')) repere = true;
      } catch (e) {}
    }
    if (!repere && /(^|;\s*)(gfp|goaffpro)[^=]*=/i.test(document.cookie || '')) repere = true;

    if (!repere) return false;
    try {
      window.sessionStorage.setItem(CLE_AFFILIATION, '1');
    } catch (e) {}
    return true;
  }

  function estDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function lire(cle) {
    try {
      return JSON.parse(window.localStorage.getItem(cle) || 'null');
    } catch (e) {
      return null;
    }
  }

  function ecrire(cle, valeur) {
    try {
      window.localStorage.setItem(cle, JSON.stringify(valeur));
    } catch (e) {
      /* navigation privée saturée — la fenêtre se contentera de la session */
    }
  }

  var SELECTEUR_FOCUS =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class MashwiPopupQuiz extends HTMLElement {
    connectedCallback() {
      if (this.initialise) return;
      this.initialise = true;

      this.panneau = this.querySelector('[data-mw-panneau]');
      this.etapes = Array.from(this.querySelectorAll('[data-mw-etape]'));
      this.champTags = this.querySelector('[data-mw-tags]');
      this.formulaire = this.querySelector('form');
      this.champCourriel = this.querySelector('input[type="email"]');
      this.bouton = this.querySelector('.mw-popup__submit');
      this.echec = this.querySelector('[data-mw-echec]');
      this.cle = this.dataset.cle || 'mw-popup-quiz';
      this.reponses = {}; // groupe → étiquette Shopify (motif-…, lieu-…, quand-…)
      this.proprietes = {}; // nom de propriété Klaviyo → libellé lisible
      this.ouvert = false;

      this.surTouche = this.surTouche.bind(this);
      this.surSortie = this.surSortie.bind(this);
      this.surDefilement = this.surDefilement.bind(this);

      this.brancherInteractions();

      if (estDesignMode()) {
        this.brancherEditeur();
        return;
      }

      if (this.dataset.pubMeta === '1' && venuDesPubsMeta()) return;

      if (this.dataset.affiliation === '1' && venuDUnAffilie()) return;

      if (this.dejaVue()) return;

      this.armerDeclencheurs();
    }

    /* ------------------------------------------------------------ fréquence */

    dejaVue() {
      var etat = lire(this.cle);
      if (!etat) return false;
      if (etat.e === 'fait') return true;
      if (etat.e === 'ferme') {
        var jours = parseInt(this.dataset.relance, 10);
        if (!jours || jours < 0) return true;
        return Date.now() - (etat.t || 0) < jours * 86400000;
      }
      return false;
    }

    /* --------------------------------------------------------- déclencheurs */

    armerDeclencheurs() {
      var self = this;

      var delai = parseInt(this.dataset.delai, 10);
      if (delai > 0) {
        this.minuterie = window.setTimeout(function () {
          self.ouvrir();
        }, delai * 1000);
      }

      this.seuilDefilement = parseInt(this.dataset.defilement, 10) || 0;
      if (this.seuilDefilement > 0) {
        window.addEventListener('scroll', this.surDefilement, { passive: true });
      }

      // Intention de sortie : souris seulement, jamais sur tactile.
      if (this.dataset.sortie === '1' && window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseout', this.surSortie);
      }
    }

    desarmerDeclencheurs() {
      window.clearTimeout(this.minuterie);
      window.removeEventListener('scroll', this.surDefilement);
      document.removeEventListener('mouseout', this.surSortie);
    }

    surDefilement() {
      var hauteur = document.documentElement.scrollHeight - window.innerHeight;
      if (hauteur <= 0) return;
      var pourcent = (window.scrollY / hauteur) * 100;
      if (pourcent >= this.seuilDefilement) this.ouvrir();
    }

    surSortie(evt) {
      if (evt.relatedTarget || evt.clientY > 0) return;
      this.ouvrir();
    }

    /* -------------------------------------------------------- interactions */

    brancherInteractions() {
      var self = this;

      this.querySelectorAll('[data-mw-fermer]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          self.fermer(true);
        });
      });

      this.querySelectorAll('[data-mw-reponse]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          var groupe = bouton.getAttribute('data-mw-reponse');
          self
            .querySelectorAll('[data-mw-reponse="' + groupe + '"]')
            .forEach(function (frere) {
              frere.setAttribute('aria-pressed', String(frere === bouton));
            });
          self.reponses[groupe] = bouton.getAttribute('data-valeur') || '';

          // La propriété Klaviyo porte le LIBELLÉ lisible (« Au chalet, les
          // fins de semaine »), pas l'étiquette machine : c'est ce qu'on veut
          // relire dans un profil et dans un segment.
          var nom = bouton.getAttribute('data-propriete');
          if (nom) self.proprietes[nom] = bouton.getAttribute('data-libelle') || '';

          self.majEtiquettes();
          self.memoriser();
          self.aller(bouton.getAttribute('data-mw-suivant') || 'courriel');
        });
      });

      this.querySelectorAll('[data-mw-retour]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          self.aller(bouton.getAttribute('data-mw-retour'));
        });
      });

      var copier = this.querySelector('[data-mw-copier]');
      if (copier) {
        copier.addEventListener('click', function () {
          self.copierCode(copier);
        });
      }

      if (this.formulaire) {
        this.formulaire.addEventListener('submit', function (evt) {
          evt.preventDefault();
          self.envoyer();
        });
      }
    }

    /* -------------------------------------------------------------- envoi */

    /**
     * Mémorise les réponses hors de la page. Appelée à CHAQUE clic, pas
     * seulement à l'envoi : c'est ce qui sauve les réponses de quelqu'un qui
     * ferme la fenêtre à la question 3 et s'inscrit deux jours plus tard.
     */
    memoriser() {
      if (window.MashwiKlaviyo) window.MashwiKlaviyo.memoriserReponses(this.proprietes);
    }

    envoyer() {
      var self = this;
      if (!this.formulaire || !this.champCourriel) return;

      // Validation native d'abord : le message « Adresse courriel invalide »
      // du navigateur, dans sa langue, sans aller déranger Klaviyo pour rien.
      if (!this.formulaire.checkValidity()) {
        this.formulaire.reportValidity();
        return;
      }
      if (this.echec) this.echec.hidden = true;

      var pont = window.MashwiKlaviyo;
      var reglages = window.mwKlaviyo || {};

      // Sans le pont (script bloqué, réseau coupé au chargement), on ne retient
      // pas le visiteur en otage : il a répondu à trois questions, il voit son
      // code. Les réponses restent en mémoire locale et repartiront à la
      // prochaine inscription.
      if (!pont || !reglages.company || !reglages.liste) {
        this.memoriser();
        this.reussite();
        return;
      }

      var props = {};
      for (var k in this.proprietes) {
        if (Object.prototype.hasOwnProperty.call(this.proprietes, k)) props[k] = this.proprietes[k];
      }
      props['Étiquettes'] = this.champTags ? this.champTags.value : '';
      props['Code de rabais'] = this.dataset.code || '';
      props['Langue'] = (document.documentElement.lang || 'fr').slice(0, 2);
      props['Page d’inscription'] = window.location.pathname;

      var source = this.dataset.source || 'Fenêtre de rabais';
      var courriel = this.champCourriel.value.trim();

      if (this.bouton) {
        this.bouton.disabled = true;
        this.bouton.setAttribute('aria-busy', 'true');
      }

      pont
        .abonner({
          courriel: courriel,
          liste: reglages.liste,
          company: reglages.company,
          source: source,
          proprietes: props,
        })
        .then(function (res) {
          if (self.bouton) {
            self.bouton.disabled = false;
            self.bouton.removeAttribute('aria-busy');
          }

          // Refus définitif = adresse invalide : c'est la seule chose que le
          // visiteur peut corriger, et la seule qu'on lui montre. Un envoi mis
          // en file a été GARDÉ : lui faire ressaisir son courriel serait faux.
          if (!res.ok && res.definitif) {
            if (self.echec) self.echec.hidden = false;
            return;
          }

          // L'événement sert à déclencher le scénario « voici ton code » dans
          // Klaviyo sans dépendre de l'entrée en liste, qui vaut aussi pour les
          // inscriptions du pied de page.
          pont.suivre({
            evenement: 'Quiz rabais complété',
            courriel: courriel,
            company: reglages.company,
            proprietes: props,
          });

          self.reussite();
        });
    }

    reussite() {
      ecrire(this.cle, { e: 'fait' });
      try {
        document.dispatchEvent(
          new CustomEvent('mashwi:lead', { detail: { source: 'Fenêtre de rabais' } })
        );
      } catch (e) {}
      this.aller('ok');
    }

    brancherEditeur() {
      var self = this;
      document.addEventListener('shopify:section:select', function (evt) {
        if (evt.target.contains(self)) self.ouvrir();
      });
      document.addEventListener('shopify:section:deselect', function (evt) {
        if (evt.target.contains(self)) self.fermer(false);
      });
    }

    /* Les réponses voyagent en étiquettes client : elles restent lisibles
       telles quelles dans la fiche du client, côté admin. */
    majEtiquettes() {
      if (!this.champTags) return;
      var base = (this.champTags.getAttribute('data-base') || 'newsletter').split(',');
      var self = this;
      Object.keys(this.reponses).forEach(function (groupe) {
        if (self.reponses[groupe]) base.push(self.reponses[groupe]);
      });
      this.champTags.value = base.join(',');
    }

    copierCode(bouton) {
      var code = this.dataset.code || '';
      var succes = function () {
        var avant = bouton.textContent;
        bouton.textContent = bouton.getAttribute('data-libelle-ok') || 'Copié';
        window.setTimeout(function () {
          bouton.textContent = avant;
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(succes, function () {});
        return;
      }

      var zone = document.createElement('textarea');
      zone.value = code;
      zone.setAttribute('readonly', '');
      zone.style.position = 'fixed';
      zone.style.opacity = '0';
      document.body.appendChild(zone);
      zone.select();
      try {
        document.execCommand('copy');
        succes();
      } catch (e) {}
      document.body.removeChild(zone);
    }

    /* ---------------------------------------------------------- ouverture */

    aller(nom) {
      this.etapes.forEach(function (etape) {
        etape.hidden = etape.getAttribute('data-mw-etape') !== nom;
      });
      var actif = this.querySelector('[data-mw-etape="' + nom + '"]');
      if (!actif) return;
      var premier = actif.querySelector(SELECTEUR_FOCUS);
      if (premier) premier.focus();
    }

    ouvrir(etape) {
      if (this.ouvert) return;
      this.desarmerDeclencheurs();
      this.ouvert = true;
      this.declencheur = document.activeElement;
      this.hidden = false;
      document.body.classList.add('mw-popup-ouvert');
      document.addEventListener('keydown', this.surTouche);
      this.aller(etape || this.etapes[0].getAttribute('data-mw-etape'));
    }

    fermer(memoriser) {
      if (!this.ouvert) return;
      this.ouvert = false;
      this.hidden = true;
      document.body.classList.remove('mw-popup-ouvert');
      document.removeEventListener('keydown', this.surTouche);
      if (memoriser && !estDesignMode()) {
        var etat = lire(this.cle);
        if (!etat || etat.e !== 'fait') ecrire(this.cle, { e: 'ferme', t: Date.now() });
      }
      if (this.declencheur && this.declencheur.focus) this.declencheur.focus();
    }

    surTouche(evt) {
      if (evt.key === 'Escape') {
        this.fermer(true);
        return;
      }
      if (evt.key !== 'Tab') return;

      var cibles = Array.from(this.panneau.querySelectorAll(SELECTEUR_FOCUS)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!cibles.length) return;

      var premier = cibles[0];
      var dernier = cibles[cibles.length - 1];

      if (evt.shiftKey && document.activeElement === premier) {
        evt.preventDefault();
        dernier.focus();
      } else if (!evt.shiftKey && document.activeElement === dernier) {
        evt.preventDefault();
        premier.focus();
      }
    }
  }

  if (!customElements.get('mashwi-popup-quiz')) {
    customElements.define('mashwi-popup-quiz', MashwiPopupQuiz);
  }
})();
